import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.scss']
})
export class LogoComponent implements OnInit {

    public Form: FormGroup;
    submitted = false;
    message = null;
    class = null;
    action = null;
    image = null;
    apiUrl = null;
    imageObj: File;

    constructor(private ActivatedRoute: ActivatedRoute, private formBuilder: FormBuilder,  private http: HttpClient, private router: Router) { }

    ngOnInit() {
        let role = localStorage.getItem('userRole');
        let user = localStorage.getItem('userId');

        this.Form = this.formBuilder.group({
            file: ['', Validators.required],
            _id: [],
        });

        this.ActivatedRoute.params.subscribe(params => {
        let id = params['id'];
            this.http.get<any>(`${environment.apiUrl}/collegeinfoById/${id}`, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
                data => {
                    (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
                    if(role != 'super-admin' && data.data.userid != user){
                        this.router.navigateByUrl('/college-details/college-info-list');
                    }
                this.image = data.data.logo;
                this.apiUrl = `${environment.apiUrl}`;
                this.Form.patchValue({
                    _id: id
                });
            },
            (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {
                console.log("Client-side error occured.");
                } else {
                console.log("Server-side error occured.");
                }
            });
        });
    }

    onImagePicked(event: Event): void {
        const FILE = (event.target as HTMLInputElement).files[0];
        this.imageObj = FILE;
    }

    get f() { return this.Form.controls; }

    onImageUpload() {
        this.submitted = true;
    
        if (this.Form.invalid) {
          return;
        }

        const imageForm = new FormData();
        imageForm.append('image', this.imageObj);
        imageForm.append('_id', this.Form.value._id);
        imageForm.append('userid', (localStorage.getItem('userRole') != 'super-admin') ? localStorage.getItem('userId') : '');

        this.http.get<any>(`${environment.apiUrl}/collegeinfoById/${this.Form.value._id}`, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
            data => {
                (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
            if(data.data && data.data.logo){
                if(confirm('Are You Sure you want to change logo?')){
                    this.http.post<any>(`${environment.apiUrl}/updateLogo/`, imageForm, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
                        data => {
                            (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
                            if(data.status == '500'){
                                this.message = data.message;
                                this.class = 'btn-primary rounded px-1 py-1';
                                window.scrollTo(document.documentElement.clientWidth, 0);
                                return 0;
                            }else{
                                this.message = 'Upload Success';
                                this.class = 'btn-success rounded px-1 py-1';
                                window.scrollTo(document.documentElement.clientWidth, 0);
                                this.ngOnInit();
                            } 
                    },
                    (err: HttpErrorResponse) => {
                        if (err.error instanceof Error) {
                        console.log("Client-side error occured.");
                        } else {
                        console.log("Server-side error occured.");
                        }
                    });
                }
            }else{
                this.http.post<any>(`${environment.apiUrl}/updateLogo/`, imageForm, { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
                    data => {
                        (data.message == 'Logged Out!') ? this.router.navigateByUrl('/auth/login') : '';
                        if(data.status == '500'){
                            this.message = data.message;
                            this.class = 'btn-primary rounded px-1 py-1';
                            window.scrollTo(document.documentElement.clientWidth, 0);
                            return 0;
                        }else{
                            this.message = 'Upload Success';
                            this.class = 'btn-success rounded px-1 py-1';
                            window.scrollTo(document.documentElement.clientWidth, 0);
                            this.ngOnInit();
                        } 
                },
                (err: HttpErrorResponse) => {
                    if (err.error instanceof Error) {
                    console.log("Client-side error occured.");
                    } else {
                    console.log("Server-side error occured.");
                    }
                });
            }
        },
        (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
            console.log("Client-side error occured.");
            } else {
            console.log("Server-side error occured.");
            }
        });
    }
}